var _style, _polygon, _polygon2, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZype(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1025 126.6",
    style: {
      enableBackground: "new 0 0 1025 126.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#000101;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "979.5,6.1 987.3,6.1 987.3,18.6 991.4,18.6 991.4,6.1 999.2,6.1 999.2,2.6 979.5,2.6 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1019.5,2.6 1012.8,13.9 1006.1,2.6 1000.5,2.6 1000.5,18.6 1004.6,18.6 1004.6,7.6 1011.3,18.6 1014.2,18.6 1020.9,7.6 1020.9,18.6 1025,18.6 1025,2.6 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M409.6,28.7l-92.4,69.1h92.4v26.2H272.5V97.8l92.2-69.1h-92.2V2.5h137.2V28.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M443.7,2.5h37.7l46.7,55.4l46.7-55.4h37.7l-68.8,81.6v39.9h-31.3V84.1L443.7,2.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M788.5,47.1c0,27.1-18.9,44.5-46.5,44.5h-64.3v32.5h-31.3V2.5H742C769.6,2.5,788.5,20,788.5,47.1z M757.3,47.1 c0-18.4-14.6-18.4-24-18.4h-55.5v36.6h55.6C742.7,65.4,757.3,65.4,757.3,47.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M853.8,27.3V52h97.2v22.6h-97.2v24.7h97.2v24.8H822.6V2.5h128.5v24.8H853.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M198.9,19.9v92.6H74.8L56,126.6h157V9.4L198.9,19.9z M156.8,0H0v117.2l14.1-10.5V14.1h123.9L156.8,0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZype);
export default __webpack_public_path__ + "static/media/zype.65cc1f64c048deac7460efb39f89e170.svg";
export { ForwardRef as ReactComponent };